import { TokenColors } from "../../types/components";
import { BaseTextProps } from "./types";

export const isHexColor = (str?: string) =>
  str ? /^#(?:[0-9a-fA-F]{3}){1,2}$/.test(str) : str;

export const isNumericCSSValue = (str?: string) =>
  str ? /^\d+(px|rem)$/.test(str) : false;

export const camelToHyphen = (str: string) => {
  return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
};

const designTokenDictionary = {
  fontSize: "--size-font",
  fontWeight: "--font-weight",
  letterSpacing: "--letter-spacing",
  lineHeight: "--line-height",
  color: "--color",
  fontFamily: "--font-family",
} as const;

const variantDictionary: Record<
  Exclude<BaseTextProps["variant"], undefined>,
  TokenColors
> = {
  default: "primary-900",
  inactive: "primary-400",
  disabled: "primary-200",
  "default-white": "neutral-000-full",
  "inactive-white": "neutral-000-inactive",
  "disabled-white": "neutral-000-disabled",
};

export const getColorByVariant = (variant?: BaseTextProps["variant"]) => {
  if (!variant) return null;

  return variantDictionary[variant];
};

export const matchToDesignToken = (
  name: keyof typeof designTokenDictionary,
  value = ""
) => {
  return `var(${designTokenDictionary[name]}-${value})`;
};

// generate the css rule string. converts the design token dictionary
// to the correct design system variable value

// might want to measure performance of this function
export const interpolateCSSProperty =
  (name: keyof typeof designTokenDictionary) => (props: BaseTextProps) => {
    // for the cases where we want to allow custom values such as custom px sizes
    // or hex colors
    if (["fontSize", "letterSpacing", "lineHeight", "color"].includes(name)) {
      if (isNumericCSSValue(props[name] as string) || isHexColor(props[name])) {
        return `${camelToHyphen(name)}: ${props[name]};`;
      }
    }

    return `${camelToHyphen(name)}: ${matchToDesignToken(name, props[name])};`;
  };
